import { Panel } from 'primereact/panel';
import { useTranslation } from "react-i18next";
import { formatarParaMoedaBRL, formatarCNPJ } from "../../../utils";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';

export default function ProtestoNacionalCnpj({ data }: { data: any }) {
  const { t } = useTranslation();

  const identificacao = data?.sinteseCadastral?.identificacao;
  const resumo = data?.resumoProtestos;

  const resumos = [
    { icon: 'pi pi-file', label: t('quantidade'), value: resumo?.total ?? 0 },
    {
      icon: 'pi pi-dollar',
      label: t('valor'),
      value: resumo?.valorTotalNumerico != null ? formatarParaMoedaBRL(Number(resumo.valorTotalNumerico)) : '0',
    },
  ];

  return (
    <Panel header={t('protestoNacionalCnpj')}>
      {identificacao && (
        <div className="grid">
          {[
            { label: t('cnpj'), value: formatarCNPJ(identificacao.cnpj) },
            { label: t('razaoSocial'), value: identificacao.razaoSocial },
            { label: t('nomeFantasia'), value: identificacao.nomeFantasia },
            { label: t('situacao'), value: identificacao.situacao },
            { label: t('dataAbertura'), value: identificacao.abertura },
            { label: t('naturezaJuridica'), value: identificacao.naturezaJuridica },
            { label: t('porte'), value: identificacao.porteEmpresa },
          ].map(f => (
            <div key={f.label} className="col p-fluid flex flex-wrap">
              <div>
                <label className="label-dados">{f.label}</label>
                <div>{f.value || '—'}</div>
              </div>
            </div>
          ))}
        </div>
      )}
      <br></br>
      <div className="flex-consulta flex-wrap gap-3">
        {resumos.map((item, index) => (
          <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }} key={index}>
            <div className="flex-consulta justify-content-between gap-5">
              <div className="flex-consulta flex-column gap-1">
                <span style={{ color: 'white' }} className="text-sm">{item.label}</span>
                <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
              </div>
              <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                <i className={item.icon} />
              </span>
            </div>
          </Card>
        ))}
      </div>
      <br></br>
      <DataTable size="small" value={data?.protestos} tableStyle={{ minWidth: '50rem' }}>
        <Column field="tipo" header={t('tipo')}></Column>
        <Column field="cartorio" header={t('cartorio')}></Column>
        <Column field="data" header={t('data')}></Column>
        <Column field="cidade" header={t('cidade')}></Column>
        <Column field="uf" header={t('uf')}></Column>
        <Column field="valor" header={t('valor')}></Column>
      </DataTable>
    </Panel>
  );
}
